export default __webpack_public_path__ + "static/media/chillmusic.949cee7e.mp3";